// Tag tabanlı hediye sistemi
// Ürün tag'lerinden hediye bilgilerini otomatik olarak alır

// Sepeti temizleme ekranında olup olmadığımızı kontrol etmek için bayrak
let isCartBeingCleared = false;
// İşlem yapılıyor mu kontrolü için bayrak
let isProcessing = false;

document.addEventListener("DOMContentLoaded", function () {
  // Sayfa yüklendiğinde sepeti kontrol et
  updateCartWithGifts();

  // Sepete ürün ekleme form olaylarını dinle
  listenForCartChanges();

  // Manual test fonksiyonu (konsola yazılabilir)
  window.testGiftSystem = function () {
    updateCartWithGifts();
  };
});

function listenForCartChanges() {
  // Tüm "sepete ekle" formlarını dinle
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", function () {
      // Form submit olduktan sonra kısa bir gecikmeyle sepeti güncelle
      setTimeout(updateCartWithGifts, 1000);
    });
  });

  // Sepetten kaldırma butonlarını izle
  document.addEventListener("click", function (event) {
    const target = event.target;

    // Kaldırma butonu veya linki tıklandıysa
    if (isRemoveButton(target) || isNearRemoveButton(target)) {
      if (window.location.pathname.includes("/cart")) {
        isCartBeingCleared = true;
        setTimeout(() => {
          isCartBeingCleared = false;
        }, 3000);
      }
    }
  });

  // Ajax ile sepet güncellemelerini dinle
  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    // Sepet kaldırma veya temizleme isteği mi kontrol et
    if (
      typeof url === "string" &&
      (url.includes("/cart/change") || url.includes("/cart/clear"))
    ) {
      isCartBeingCleared = true;
      setTimeout(() => {
        isCartBeingCleared = false;
      }, 3000);
    }

    const fetchPromise = originalFetch(url, options);

    // Sepet işlemlerinden sonra sepeti kontrol et
    if (
      typeof url === "string" &&
      (url.includes("/cart/add") ||
        url.includes("/cart/update") ||
        url.includes("/cart/change"))
    ) {
      // Sadece sepet temizleme modunda değilsek ve hediye ekleme işlemi değilse
      if (!isCartBeingCleared && !url.includes("properties[_hediye_urun]")) {
        setTimeout(updateCartWithGifts, 1000);
      }
    }

    return fetchPromise;
  };
}

// Bir elemanın kaldırma butonu olup olmadığını kontrol et
function isRemoveButton(element) {
  if (!element || !element.tagName) return false;

  return (
    (element.tagName === "A" &&
      element.href &&
      (element.href.includes("/cart/change") ||
        element.href.includes("remove"))) ||
    (element.dataset &&
      (element.dataset.cartRemove !== undefined ||
        element.dataset.remove !== undefined)) ||
    (element.classList &&
      (element.classList.contains("cart__remove-btn") ||
        element.classList.contains("cart-remove") ||
        element.classList.contains("cart__remove") ||
        element.classList.contains("remove")))
  );
}

function isNearRemoveButton(element) {
  if (!element || !element.tagName) return false;

  const parent = element.parentElement;
  if (parent && isRemoveButton(parent)) {
    return true;
  }

  if (
    element.tagName === "I" ||
    element.tagName === "SPAN" ||
    element.tagName === "SVG"
  ) {
    if (
      element.classList &&
      (element.classList.contains("icon-remove") ||
        element.classList.contains("icon-trash") ||
        element.classList.contains("icon-close"))
    ) {
      return true;
    }
  }

  return false;
}

// Ürün bilgilerini Shopify API'den al
async function getProductInfo(productId) {
  try {
    const url = `/products/${productId}.js`;
    const response = await fetch(url);

    if (!response.ok) {
      return null;
    }

    const product = await response.json();
    return product;
  } catch (error) {
    return null;
  }
}

// Ürünün tag'lerinden hediye bilgilerini çıkar
function extractGiftInfoFromTags(tags) {
  const giftInfo = {
    hasGift: false,
    giftTitle: null,
    giftProductId: null,
  };

  if (!Array.isArray(tags)) {
    return giftInfo;
  }

  tags.forEach((tag) => {
    // gift-title_ tag'ini kontrol et
    if (tag.startsWith("gift-title_")) {
      giftInfo.hasGift = true;
      giftInfo.giftTitle = tag.replace("gift-title_", "").replace(/_/g, " ");
    }

    // gift-product_ tag'ini kontrol et
    if (tag.startsWith("gift-product_")) {
      giftInfo.giftProductId = tag.replace("gift-product_", "");
    }
  });

  return giftInfo;
}

// Ana sepet kontrol fonksiyonu
async function updateCartWithGifts() {
  if (isCartBeingCleared || isProcessing) {
    return;
  }

  isProcessing = true;

  try {
    // Mevcut sepeti al
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const actionsNeeded = [];

    // Sepetteki her ürün için kontrol et
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];

      // Hediye ürünü değilse (hediye ürünleri _hediye_urun property'sine sahip)
      if (!item.properties || !item.properties._hediye_urun) {
        // Ürün bilgilerini al - önce handle ile dene
        let productInfo = null;

        if (item.handle) {
          productInfo = await getProductInfo(item.handle);
        }

        // Handle ile alamazsak product_id ile dene
        if (!productInfo && item.product_id) {
          productInfo = await getProductInfo(item.product_id);
        }

        if (productInfo) {
          // Tag'lerden hediye bilgilerini çıkar
          const giftInfo = extractGiftInfoFromTags(productInfo.tags);

          if (
            giftInfo.hasGift &&
            giftInfo.giftProductId &&
            giftInfo.giftTitle
          ) {
            // Bu ürün için hediye sepette mi kontrol et
            const existingGift = cart.items.find(
              (cartItem) =>
                cartItem.variant_id &&
                cartItem.variant_id.toString() === giftInfo.giftProductId &&
                cartItem.properties &&
                cartItem.properties._hediye_icin === item.variant_id.toString()
            );

            if (!existingGift) {
              actionsNeeded.push({
                action: "add",
                mainProductId: item.variant_id.toString(),
                giftProductId: giftInfo.giftProductId,
                giftTitle: giftInfo.giftTitle,
                quantity: item.quantity,
              });
            } else if (existingGift.quantity !== item.quantity) {
              actionsNeeded.push({
                action: "update",
                itemId: existingGift.id,
                quantity: item.quantity,
              });
            }
          }
        }
      }
    }

    // Gerekli işlemleri sırayla yap
    if (actionsNeeded.length > 0) {
      await processActions(actionsNeeded, 0);
    }
  } catch (error) {
    // Hata sessizce göz ardı edilir
  } finally {
    isProcessing = false;
  }
}

// İşlemleri sırayla gerçekleştir
async function processActions(actions, index) {
  if (index >= actions.length) {
    return;
  }

  const action = actions[index];

  try {
    if (action.action === "add") {
      await addGiftToCart(action);
    } else if (action.action === "update") {
      await updateGiftQuantity(action.itemId, action.quantity);
    }

    // Bir sonraki işleme geç
    setTimeout(() => {
      processActions(actions, index + 1);
    }, 500);
  } catch (error) {
    // Hata olsa bile devam et
    setTimeout(() => {
      processActions(actions, index + 1);
    }, 500);
  }
}

// Hediye ürünü sepete ekle
async function addGiftToCart(giftData) {
  const formData = {
    items: [
      {
        id: giftData.giftProductId,
        quantity: giftData.quantity,
        properties: {
          _hediye_urun: giftData.giftTitle,
          _hediye_icin: giftData.mainProductId,
        },
      },
    ],
  };

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `${giftData.giftTitle} eklenemedi: ${response.status} - ${errorText}`
    );
  }

  const data = await response.json();

  // Gerçekten sepete eklendi mi kontrol et
  const addedItem = data.items?.find(
    (item) =>
      item.variant_id.toString() === giftData.giftProductId &&
      item.properties?._hediye_urun === giftData.giftTitle
  );

  if (addedItem) {
    showNotification(
      `"${giftData.giftTitle}" hediye olarak sepetinize eklendi!`
    );
  }

  return data;
}

// Hediye ürün miktarını güncelle
async function updateGiftQuantity(itemId, newQuantity) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: itemId,
      quantity: newQuantity,
    }),
  });

  const data = await response.json();
  return data;
}

// Bildirim göster
function showNotification(message) {
  const notification = document.createElement("div");
  notification.className = "gift-notification";
  notification.innerHTML = message;
  notification.style.cssText =
    "position: fixed; top: 20px; right: 20px; background: #4CAF50; color: white; padding: 15px; border-radius: 4px; z-index: 9999; animation: fadeIn 0.3s, fadeOut 0.3s 2.7s forwards;";

  document.body.appendChild(notification);

  setTimeout(() => {
    if (notification.parentNode) {
      document.body.removeChild(notification);
    }
    window.location.reload(); // Sayfa yenilenir
  }, 2000);
}

// CSS animasyonları
const style = document.createElement("style");
style.innerHTML = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeOut {
    from { opacity: 1; transform: translateY(0); }
    to { opacity: 0; transform: translateY(-20px); }
  }
`;
document.head.appendChild(style);
